import { createPinia } from "pinia";
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { MaskInput } from 'vue-3-mask';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap';
import './assets/main.scss'

const pinia = createPinia();
const app = createApp(App);

app.component('MaskInput', MaskInput);
app.use(router);
app.use(pinia);
app.mount("#app");